'use strict';

/* globals angular */

var _ = require('lodash');

var ALLFEATURES = [
  { name: 'dtm', enabled: 1 },
  { name: 'chat_support', enabled: 1 },
  { name: 'overlays', enabled: 1 },
  { name: 'annotations', enabled: 1 },
  { name: 'email_support', enabled: 1 },
  { name: 'sharing', enabled: 1 },
  { name: 'file_export', enabled: 1 },
  { name: 'gcp', enabled: 0 },
  { name: 'measurements', enabled: 1 }
];

/** @PlanStore */
var Store = function (
    $q, $state, Flux, APP_DISPATCHER_ID, SiteStore, $http,
    IdentityService, OrganizationStore, SettingsStore, ResourceHelper
) {
  var ORGPLANPUBNUBPUBKEY = IdentityService.get('pubnub.payments');
  // Intialize the store
  var PlanStore = Flux.Store.create({
    name: 'PlanStore',
    events: {
      Changed: true,
      Reactivated: true,
      Cancelled: true,
      Updated: true,
      Error: true
    }
  });

  /**
   * Initial empty store state
   * @var {object} $state
   */
  PlanStore.$state = {
    current : {}, // Project Plan
    projectFeatures: ALLFEATURES, // Project Features
    projectId : '',
    orgPlan : {}, // Apollo Plan
    externalCustomer : null,
    externalSubscription : null,  // Chargebee Subscription
    externalPlan : null, // Chargebee Plan
    externalPlanAddons : null, // Chargebee Addons <> Chargebee Plan
    planFeatures : ALLFEATURES, // Organization Features
    dirty: true
  };

  /**
   * Intialize the store bindings and initial data.
   * @constructor
   */
  PlanStore.init = function init () {
    var d = Flux.Dispatcher.get(APP_DISPATCHER_ID);
  }.bind(this);

  /**
   * Sets the internal state for the Store (used by the Router logic to place the current Org Plan).
   * @param {object} [state] An PlanStore state object.
   */
  PlanStore.setState = (state) => {

    angular.extend(PlanStore.$state, state);
    // PlanStore.emit(PlanStore.Events.Changed);
  };

  /**
   * Finds whether or not a project or an organization has a feature enabled
   * @param  {[string]} type    | either 'project' or 'organization'
   * @param  {[string]} feature | name of feature object in the chargebee plan meta_data
   * @return {[boolean]}
   */
  PlanStore.checkFeature = (type, feature) => {

    var foundFeature = (type === 'project') ?
        _.find(PlanStore.get('projectFeatures'), { name: feature }) :
        _.find(PlanStore.get('planFeatures'), { name: feature });
    return foundFeature ? !!foundFeature.enabled : false;
  };

  PlanStore.isHppPlan = () => {

    const plan = PlanStore.get('orgPlan');
    return plan && !plan.externalSubscriptionId;
  };

  PlanStore.fetchExternalPlanSubData = () => {
    // TODO move all payment-api requests to a resource because $http is hoop-lah
    var urlPlan = IdentityService.getPaymentsApiUri() + 'plans/' + PlanStore.get('orgPlan').name; // name => plan id in Chargebee
    var httpConfigPlan = { url: urlPlan, method: 'GET', cache: false };
    var urlSub = IdentityService.getPaymentsApiUri() + 'organizations/' + OrganizationStore.get('current').id + '/subscriptions/' + PlanStore.get('orgPlan').externalSubscriptionId; // name => plan id in Chargebee
    var httpConfigSub = { url: urlSub, method: 'GET', cache: false };
    var promises = [$http(httpConfigPlan), $http(httpConfigSub)];
    return $q.all(promises)
    .then(function (values) {
      var externalPlan = values[0].data.data.plan;
      var externalPlanAddons = values[0].data.data.addons;
      var externalCustomer = values[1].data.data.customer;
      var externalSubscription = values[1].data.data.subscription;
      PlanStore.$set('externalPlan', externalPlan);
      PlanStore.$set('externalCustomer', externalCustomer);
      PlanStore.$set('externalSubscription', externalSubscription);
      if (externalPlanAddons) {
        var addons = {};
        for (var i in externalPlanAddons) {
          var obj = externalPlanAddons[i].addon;
          var key = obj.unit;
          addons[key] = obj;
        }
        PlanStore.$set('externalPlanAddons', addons);
      }

      return;
    })
    .catch(function () {
      console.warn('Could not find the Chargebee plan');
      PlanStore.$set('externalPlan', {});
      PlanStore.$set('externalCustomer', {});
      PlanStore.$set('externalSubscription', {});
      return;
    });
  };

  PlanStore.preloadOrgPlanData = () => {
    PlanStore.setOrgPlanFeatures(OrganizationStore.get('plan'));
    // TODO replace this, we don't need to fetch this data every time we change states
    if (PlanStore.get('orgPlan') && !PlanStore.get('externalPlan')) {
      if (PlanStore.get('orgPlan').status && PlanStore.get('orgPlan').externalSubscriptionId) {
        return PlanStore.fetchExternalPlanSubData()
        .then(function () {
          PlanStore.syncSubscribe(); // subscribe for pubnub notifications
          PlanStore.emit(PlanStore.Events.Changed);
        });
      }
      else {
        return $q(function (resolve) {
          PlanStore.emit(PlanStore.Events.Changed);
          return resolve();
        });
      }
    }
    else {
      return $q(function (resolve) {
        PlanStore.emit(PlanStore.Events.Changed);
        return resolve();
      });
    }
  };

  PlanStore.resetOrgPlan = () => {

    PlanStore.$set('dirty', true); // This is to be sure that the next time we fetch a project - the project plan invalidates (feature updates)
    OrganizationStore.$set('dirty', true);
    var PlanResource = ResourceHelper.getResource('Plan');
    return PlanResource.find(PlanStore.get('orgPlan').id, {
      params: {
        include: 'features'
      },
      bypassCache: true
    })
    .then((plan) => {

      OrganizationStore.$set('plan', plan); // assumes one plan per organization
      PlanStore.$set('current', plan);
      PlanStore.$set('orgPlan', plan);
      PlanStore.$set('externalPlan', null);
      PlanStore.$set('externalCustomer', null);
      PlanStore.$set('externalSubscription', null);
      return PlanStore.preloadOrgPlanData();
    });
  };

  PlanStore.setOrgPlanFeatures = (plan) => {
    PlanStore.$set('orgPlan', plan);
    if (PlanStore.get('orgPlan').features) {
      PlanStore.$set('planFeatures', PlanStore.get('orgPlan').features.length ?
        PlanStore.get('orgPlan').features :
        ALLFEATURES
      );
    }
    else {
      PlanStore.$set('planFeatures', ALLFEATURES);
    }
  };

  PlanStore.setProjPlanFeatures = () => {

    if (PlanStore.get('current')) {
      PlanStore.$set('projectFeatures', PlanStore.get('current').features.length ?
        PlanStore.get('current').features :
        ALLFEATURES
      );
    }
    else {
      // This is for Skycatch Admins
      PlanStore.$set('projectFeatures', ALLFEATURES);
    }
  };

  this._handleSiteStoreViewing = function () {
    // This is the plan associated to the viewed project, not the organization's plan
    var site = SiteStore.get('current');
    if (site.projectId !== PlanStore.get('projectId') || PlanStore.get('dirty')) {
      var ProjectResource = ResourceHelper.getResource('Project');
      return ProjectResource.find(site.projectId, {
        params: {
          include: 'plans.features'
        }
      })
      .then(function (project) {
        var orgPlan = _.find(project.plans, function(plan) { // this case should not exist [Bad Data]
          return plan.organizationId === IdentityService.getCurrentOrganization().id;
        });
        if (orgPlan) {
          PlanStore.$set('current', orgPlan);
          PlanStore.$set('projectId', site.projectId);
          PlanStore.$set('dirty', false);
          PlanStore.setProjPlanFeatures();
          PlanStore.emit(PlanStore.Events.Changed);
          return orgPlan;
        }
        else {
          console.warn('No User - Plan found');
          PlanStore.$set('current', null);
          PlanStore.$set('projectId', site.projectId);
          PlanStore.setProjPlanFeatures();
          PlanStore.emit(PlanStore.Events.Changed);
          return;
        }
      });
    }
  };

  PlanStore.syncSubscribe = () => { // subscribe to all events by PLAN
    var SyncStore = Flux.Store.get('SyncStore');
    SyncStore.subscribe(ORGPLANPUBNUBPUBKEY, 'orgPlan-' + PlanStore.get('orgPlan').externalSubscriptionId, {
      message: (msg) => {
        if (msg.status === 'changed' || msg.status === 'cancelled' || msg.status === 'reactivated' || msg.status === 'created') {
          PlanStore.resetOrgPlan().then(() => {
            switch (msg.status) {
            case 'changed':
              PlanStore.emit(PlanStore.Events.Updated);
              break;
            case 'reactivated':
              PlanStore.emit(PlanStore.Events.Reactivated);
              break;
            case 'cancelled':
              PlanStore.emit(PlanStore.Events.Cancelled);
              break;
            }
          });
        }
        else if (msg.status === 'error') {
          PlanStore.emit(PlanStore.Events.Error);
        }
      }
    });
  };

  PlanStore.clearStore = function() {
    PlanStore.$set('current', null); // Project Plan
    PlanStore.$set('projectFeatures', ALLFEATURES); // Project Features
    PlanStore.$set('projectId', '');
    PlanStore.$set('orgPlan', null); // Apollo Plan
    PlanStore.$set('externalCustomer', null);
    PlanStore.$set('externalSubscription', null);  // Chargebee Subscription
    PlanStore.$set('externalPlan', null); // Chargebee Plan
    PlanStore.$set('externalPlanAddons', null); // Chargebee Addons <> Chargebee Plan
    PlanStore.$set('planFeatures', ALLFEATURES); // Organization Features
    PlanStore.$set('dirty', true);
  };

  SiteStore.on(SiteStore.Events.Viewing, this._handleSiteStoreViewing.bind(this));
  return PlanStore;
};

Store.$inject = [
  '$q', '$state', 'sbFlux', 'APP_DISPATCHER_ID', 'SiteStore', '$http',
  'IdentityService', 'OrganizationStore', 'SettingsStore', 'ResourceHelper'
];

module.exports = Store;



// WEBPACK FOOTER //
// ./src/app/dash/dataStores/PlanStore.js